module.exports = __webpack_public_path__ + "static/media/fessier.d242dff6.jpg";